import { IRouterConfig, lazy } from 'ice';
import Layout from '@/Layouts/BasicLayout';
import LoginWrapper from '@/components/LoginWrapper';

const Login = lazy(() => import('@/pages/Login'));
const Qrcode = lazy(() => import('@/pages/Login/Qrcode'));
const ActivityDetail = lazy(() => import('@/pages/OfflineActivities/ActivityDetail'))
const CourseDetail = lazy(() => import('@/pages/OnlineClassroom/CourseDetail'))
const CoursePlay = lazy(() => import('@/pages/OnlineClassroom/CoursePlay'))
const MaterialDetail = lazy(() => import('@/pages/OnlineClassroom/MaterialDetail'))
const QASectionDetail = lazy(() => import('@/pages/QASection/QASectionDetail'))
const EditProblem = lazy(() => import('@/pages/QASection/EditProblem'))
const LableProblem = lazy(() => import('@/pages/QASection/LableProblem'))
const Vote = lazy(() => import('@/pages/Vote/index'))
const LecturerRanking = lazy(() => import('@/pages/LecturerRanking'))
const Examination = lazy(() => import('@/pages/Examination'))
const ExaminationPrepare = lazy(() => import('@/pages/Examination/ExaminationPrepare'))
const ExaminationResult = lazy(() => import('@/pages/Examination/ExaminationResult'));
const User = lazy(() => import('@/pages/User'))
const StudentUser = lazy(() => import('@/pages/StudentUser'))
const ForumDetail = lazy(() => import('@/pages/Forum/ForumDetail'))
const AddForum = lazy(() => import('@/pages/Forum/AddForum'))
const GeneraVoteDetails = lazy(() => import('@/pages/Vote/GeneraVoteDetails'))
const SelectionVoteDetails = lazy(() => import('@/pages/Vote/SelectionVoteDetails'))
const VoteResult = lazy(() => import('@/pages/Vote/VoteResult'))
const LearningMapDetail = lazy(() => import('@/pages/Training/LearningMapDetail'))
const TrainingClassDetail = lazy(() => import('@/pages/Training/TrainingClassDetail'))
const RecruitModel = lazy(() => import('@/pages/Training/RecruitModel'))
const Authentication = lazy(() => import('@/pages/User/Authentication'))
const Activity = lazy(() => import('@/pages/User/Activity'))
const LectureActivities = lazy(() => import('@/pages/Lecture/LectureActivities'))

const TrainingBay = lazy(() => import('@/pages/TrainingBay'));
const Dashboard = lazy(() => import('@/pages/Dashboard'));
const LectureHome = lazy(() => import('@/pages/LectureHome'));
const UserHome = lazy(() => import('@/pages/UserHome'));
const Home = lazy(() => import('@/pages/Home'));
const Course = lazy(() => import('@/pages/Course'));
const FAQ = lazy(() => import('@/pages/FAQ'));
const Lecture = lazy(() => import('@/pages/Lecture'));
const Training = lazy(() => import('@/pages/Training'));
const NotFound = lazy(() => import('@/components/NotFound'));

const routerConfig: IRouterConfig[] = [
  {
    path: '/login',
    component: Login,
    pageConfig: {
      title: '登录',
      scrollToTop: true,
    },
  },
  {
    path: '/qrcode',
    component: Qrcode,
    pageConfig: {
      title: '企业微信登录',
      scrollToTop: true,
    },
  },
  {
    path: '/',
    component: Layout,
    wrappers: [LoginWrapper],
    children: [
      {
        path: '/addForum',
        component: AddForum,
        pageConfig: {
          title: '创建帖子',
          scrollToTop: true,
        },
      },
      {
        path: '/lectureHome',
        component: LectureHome,
        pageConfig: {
          title: '讲师首页',
          scrollToTop: true,
        },
      },
      {
        path: '/lectureActivities',
        component: LectureActivities,
        pageConfig: {
          title: '讲师赋能活动',
          scrollToTop: true,
        },
      },
      {
        path: '/recruitModel',
        component: RecruitModel,
        pageConfig: {
          title: '学习地图闯关模式',
          scrollToTop: true,
        },
      },
      {
        path: '/learningMapDetail',
        component: LearningMapDetail,
        pageConfig: {
          title: '学习地图详情',
          scrollToTop: true,
        },
      },
      {
        path: '/voteResult',
        component: VoteResult,
        pageConfig: {
          title: '投票答题结果',
          scrollToTop: true,
        },
      },
      {
        path: '/selectionVoteDetails',
        component: SelectionVoteDetails,
        pageConfig: {
          title: '评选投票答题',
          scrollToTop: true,
        },
      },
      {
        path: '/generaVoteDetails',
        component: GeneraVoteDetails,
        pageConfig: {
          title: '普通投票答题',
          scrollToTop: true,
        },
      },
      {
        path: '/forumDetail',
        component: ForumDetail,
        pageConfig: {
          title: '帖子详情',
          scrollToTop: true,
        },
      },
      {
        path: '/lecturerRanking',
        component: LecturerRanking,
        pageConfig: {
          title: '讲师排行榜',
          scrollToTop: true,
        },
      },
      {
        path: '/examination',
        component: Examination,
        pageConfig: {
          title: '考试',
          scrollToTop: true,
        },
      },
      {
        path: '/examinationPrepare',
        component: ExaminationPrepare,
        pageConfig: {
          title: '考试准备',
          scrollToTop: true,
        },
      },
      {
        path: '/ExaminationResult',
        component: ExaminationResult,
        pageConfig: {
          title: '考试结果',
          scrollToTop: true,
        },
      },
      {
        path: '/studentUser',
        component: StudentUser,
        pageConfig: {
          title: '学员个人中心',
          scrollToTop: true,
        },
      },
      {
        path: '/user',
        component: User,
        pageConfig: {
          title: '个人中心',
          scrollToTop: true,
        },
      },

      {
        path: '/vote',
        component: Vote,
        pageConfig: {
          title: '投票',
          scrollToTop: true,
        },
      },
      {
        path: '/lableProblem',
        component: LableProblem,
        pageConfig: {
          title: '标签问题',
          scrollToTop: true,
        },
      },
      {
        path: '/editProblem',
        component: EditProblem,
        pageConfig: {
          title: '我要提问',
          scrollToTop: true,
        },
      },
      {
        path: '/QASectionDetail',
        component: QASectionDetail,
        pageConfig: {
          title: '问答详情',
          scrollToTop: true,
        },
      },
      {
        path: '/home',
        component: Home,
        pageConfig: {
          title: '首页',
          scrollToTop: true,
        },
      },
      {
        path: '/course',
        component: Course,
        pageConfig: {
          title: '课程库',
          scrollToTop: true,
        },
      },
      {
        path: '/faq',
        component: FAQ,
        pageConfig: {
          title: '社区',
          scrollToTop: true,
        },
      },
      {
        path: '/authentication',
        component: Authentication,
        pageConfig: {
          title: '认证区',
          scrollToTop: true,
        },
      },
      {
        path: '/trainingBay',
        component: TrainingBay,
        pageConfig: {
          title: '培训区',
          scrollToTop: true,
        },
      },
      {
        path: '/lecture',
        component: Lecture,
        pageConfig: {
          title: '讲师库',
          scrollToTop: true,
        },
      },
      {
        path: '/trainingClassDetail',
        component: TrainingClassDetail,
        pageConfig: {
          title: '培训区',
          scrollToTop: true,
        },
      },
      {
        path: '/training',
        component: Training,
        pageConfig: {
          title: '培训区',
          scrollToTop: true,
        },
      },
      {
        path: '/activityDetail',
        component: ActivityDetail,
        pageConfig: {
          title: '活动详情',
          scrollToTop: true,
        },
      },
      {
        path: '/materialDetail',
        component: MaterialDetail,
        pageConfig: {
          title: '素材详情',
          scrollToTop: true,
        },
      },
      {
        path: '/courseDetail',
        component: CourseDetail,
        pageConfig: {
          title: '课程详情',
          scrollToTop: true,
        },
      },
      {
        path: '/coursePlay',
        component: CoursePlay,
        pageConfig: {
          title: '课程播放',
          scrollToTop: true,
        },
      },
      {
        path: '/userHome',
        component: UserHome,
        pageConfig: {
          title: '用户端首页',
          scrollToTop: true,
        },
      },
      {
        path: '/',
        exact: true,
        component: UserHome,
        pageConfig: {
          title: '首页',
          scrollToTop: true,
        },
      },
      {
        component: NotFound,
        pageConfig: {
          title: '页面未找到',
          scrollToTop: true,
        },
      },
    ],
  },
];

export default routerConfig;
